import React from "react";
import { useTranslation } from "react-i18next";
import { ModalFooter } from "reactstrap";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type Props = {
    isValidateButtonEnabled: boolean;
    onCancel: () => void;
    onValidate: () => void;
};

export default function AssociateModalFooter({
    isValidateButtonEnabled,
    onCancel,
    onValidate,
}: Props) {
    const { t } = useTranslation();
    return (
        <ModalFooter className="border-top-0">
            <CustomSecondaryColorButton
                data-testid="fidelity-shops-associate-cancel-button"
                outline
                variant="light"
                className="fed_btn_AFcancel"
                onClick={onCancel}
                rounded
            >
                {t("Cancel")}
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                data-testid="fidelity-shops-associate-validate-button"
                rounded
                variant="primary"
                className="fed_btn_AFvalidate"
                disabled={!isValidateButtonEnabled}
                onClick={onValidate}
            >
                {t("Validate")}
            </CustomMainColorButton>
        </ModalFooter>
    );
}
